import { library } from '@fortawesome/fontawesome-svg-core' // Core SVG
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome' // Integration

import * as icons from './icons'
import type { App } from 'vue'

export default {
  install: (app: App) => {
    library.add(Object.values(icons))
    app.component('font-awesome-icon', FontAwesomeIcon)
  },
}
